import { LOCK_DURATION_OPTIONS } from "@/config";
import { useLockedPositionAPY } from "@/hooks";
import { memo } from "react";
import { twMerge } from "tailwind-merge";
import { DurationOptionCard } from "./DurationOptionCard";

interface DurationSelectorProps {
    value: number;
    onChange: (value: number) => void;
}

interface DurationSelectorOptionProps {
    value: number;
    label: string;
    selectedValue: number;
    onSelect: (value: number) => void;
}

const DurationSelectorOption = memo(function DurationSelectorOption({
    value,
    label,
    selectedValue,
    onSelect,
}: DurationSelectorOptionProps) {
    const { apy } = useLockedPositionAPY(value);
    const isSelected = selectedValue === value;

    const containerClassName = twMerge(
        isSelected && "border-primary bg-primary/15",
        !isSelected && "border-dark/10 bg-white/5",
        "max-h-auto hover:border-primary/40 hover:bg-primary/5",
    );

    return (
        <DurationOptionCard
            title={label}
            subtitle={`${apy}% APY`}
            onClick={() => onSelect(value)}
            containerClassName={containerClassName}
            titleClassName={twMerge("text-[14px] leading-[18px]", isSelected && "text-primary")}
            subtitleClassName={twMerge("text-[14px] leading-[18px] text-muted", isSelected && "text-dark")}
        />
    );
});

DurationSelectorOption.displayName = "DurationSelectorOption";

export function DurationSelector({ value, onChange }: DurationSelectorProps) {
    return (
        <section className="mt-4">
            <div className="flex flex-row items-center gap-1 mb-1">
                <div className="text-dark text-sm">Choose unlock period:</div>
                {/* <Tooltip
                    title={`
                    Time you wait after requesting a withdrawal.
                    Higher wait time increases your APY and allows you to vote for a wider range of yield sources.
                `}
                >
                    <span className="inline-block cursor-help">
                        <IconButton size="sm" variant="ghost" className="p-0">
                            <Icon name="Info" className="text-gray-400 text-xs w-4 h-4" />
                        </IconButton>
                    </span>
                </Tooltip> */}
            </div>
            <div className="grid grid-cols-3 gap-3 mt-3">
                {LOCK_DURATION_OPTIONS.map((option) => (
                    <DurationSelectorOption
                        key={option.value}
                        value={option.value}
                        label={option.label}
                        selectedValue={value}
                        onSelect={onChange}
                    />
                ))}
            </div>
        </section>
    );
}
